import { StandardProps } from "../componentMap";
import { DressipiUI } from "./DressipiUI";

export function Dressipi({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  return <DressipiUI product={product} runtimeConfig={runtimeConfig} />;
}
